import React, { useEffect } from "react";
import Sidebar from "../utils/Sidebar";
import Header from "../utils/Header";
import Footer from "../utils/Footer";
import { loadScript } from "../../js/loadScripts";

const BaseLayout = ({ children }) => {
  const SidebarOptions = [
    {
      name: "Dashboard",
      icon: "bi bi-easel2-fill",
      route: "dashboard",
      params: [],
      dropdown: [],
      allowedRoles: ["Admin", "Insegnante"],
    },
    {
      name: "Scuole",
      icon: "bi bi-mortarboard-fill",
      route: null,
      params: [],
      allowedRoles: ["Admin", "Insegnante"],
      dropdown: [
        {
          name: "Anagrafica scuole",
          route: "schools",
          params: [],
          allowedRoles: ["Admin"],
        },
        {
          name: "Anagrafica classi",
          route: "classes",
          params: [],
          allowedRoles: ["Admin", "Insegnante"],
        },
        {
          name: "Anagrafica insegnanti",
          route: "teachers",
          params: [],
          allowedRoles: ["Admin"],
        },
        {
          name: "Anagrafica studenti",
          route: "students",
          params: [],
          allowedRoles: ["Admin", "Insegnante"],
        },
      ],
    },
    {
      name: "Luoghi della cultura",
      icon: "bi bi-bank2",
      route: null,
      params: [],
      allowedRoles: ["Admin", "Insegnante"],
      dropdown: [
        // {
        //   name: "Nuovo luogo",
        //   route: "culturalPlaces/add",
        //   params: [],
        //   allowedRoles: ["Admin", "Insegnante"],
        // },
        {
          name: "Elenco luoghi",
          route: "culturalPlaces",
          params: [],
          allowedRoles: ["Admin", "Insegnante"],
        },
      ],
    },
    {
      name: "Eventi",
      icon: "bi bi-calendar3",
      route: null,
      params: [],
      allowedRoles: ["Admin", "Insegnante"],
      dropdown: [
        // {
        //   name: "Nuovo evento",
        //   route: "events/add",
        //   params: [],
        //   allowedRoles: ["Admin", "Insegnante"],
        // },
        {
          name: "Elenco eventi",
          route: "events",
          params: [],
          allowedRoles: ["Admin", "Insegnante"],
        },
      ],
    },
    {
      name: "Challenge",
      icon: "bi bi-fire",
      route: null,
      params: [],
      allowedRoles: ["Insegnante"],
      dropdown: [
        {
          name: "Crea Challenge",
          route: "challenges/add",
          params: [],
          allowedRoles: ["Insegnante"],
        },
        {
          name: "Elenco Challenge",
          route: "challenges",
          params: [],
          allowedRoles: ["Insegnante"],
        },
      ],
    },
    {
      name: "Gestione Punti",
      icon: "bi bi-star",
      route: null,
      params: [],
      allowedRoles: ["Insegnante"],
      dropdown: [
        {
          name: "Selfie",
          route: "points/selfie",
          params: [],
          allowedRoles: ["Insegnante"],
        },
        {
          name: "Chat",
          route: "points/chat",
          params: [],
          allowedRoles: ["Insegnante"],
        },
        {
          name: "Ricerca",
          route: "points/search",
          params: [],
          allowedRoles: ["Insegnante"],
        },
      ],
    },
    {
      name: "Utenti",
      icon: "bi bi-people-fill",
      route: null,
      params: [],
      allowedRoles: ["Admin"],
      dropdown: [
        // {
        //   name: "Nuovo utente",
        //   route: "users/add",
        //   params: [],
        //   allowedRoles: ["Admin"],
        // },
        {
          name: "Elenco admin",
          route: "users",
          params: [],
          allowedRoles: ["Admin"],
        },
      ],
    },
  ];

  let scriptLoadingStatus = true;
  useEffect(() => {
    if (scriptLoadingStatus) {
      loadScript("../../assets/js/defaultmenu.min.js");
      scriptLoadingStatus = false;
    }
  }, []);
  return (
    <div className="main-wrapper content" id="main-wrapper">
      <div className="page">
        <Header />
        <Sidebar sidebar={SidebarOptions} />
        <div className="main-content app-content">{children}</div>
        <Footer />
      </div>
    </div>
  );
};

export default BaseLayout;
